import React from 'react'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import 'moment/locale/zh-cn'

export const MN_ANT_PREFIX = 'mn-ant'
export const MN_ANT_ICON_PREFIX = 'mn-anticon'
export const MN_ANT_PREFIX_FLAG = '__MEINIAN_ANTD_PREFIX__'

export function enableMnAntdPrefix() {
  if (typeof window !== 'undefined') {
    window[MN_ANT_PREFIX_FLAG] = true
  }
}

function shouldUseMnAntdPrefix() {
  return typeof window !== 'undefined' && window[MN_ANT_PREFIX_FLAG] === true
}

export default function MnAntdProvider({ children }) {
  if (!shouldUseMnAntdPrefix()) {
    return <>{children}</>
  }

  return (
    <ConfigProvider prefixCls={MN_ANT_PREFIX} iconPrefixCls={MN_ANT_ICON_PREFIX} locale={zhCN}>
      {children}
    </ConfigProvider>
  )
}
